import TEMPLATE_URL from 'emun.auth/users/user-parser.htm'
import controller from 'emun.auth/users/user-parser.controller'
import modals from 'webmodals/modals'

const NOOP = () => { };

export default ({
    size = 'md',
    backdrop = 'static',
    templateUrl = TEMPLATE_URL,
    title = 'User Bulk Pad...',
    subTitle = 'Enter user names separated by comma or white-space',
    view = 'cards',
    selected = {},
    onToggle = NOOP,
    onUserSelected = NOOP,
    onUserDeselected = NOOP,
} = {}) => modals.open({
        size,
        backdrop,
        templateUrl,
        controller,
        bindToController: true,
        controllerAs: '$ctrl',
        resolve: {
            options: () => ({
                title,
                subTitle,
                onUserSelected,
                onUserDeselected,
                view,
            })
        }
    }).result;